class RequestsList {
  constructor() {
    this.transactionNumber = null;
    this.status = null;
    this.date = null;
    this.type = null;
    this.total = null;
    this.verifiedAt = null;
    this.totalFiltered = null;
    this.availableBalance = null;
    this.accountStatus = null;
    this.currency = null;
    this.requests = [];

    this.pageParams = {
      recordsTotal: null,
      recordsFiltered: null,
      limit: null,
      page: null,
      offset: null,
      orderBy: null
    }
  }
}

export default RequestsList;
  


// WEBPACK FOOTER //
// ./client/app/pages/requests/model/requests.model.js